import React, {Component} from 'react'
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {Mutation} from 'react-apollo'
import gql from 'graphql-tag'

const MUTATION = gql`mutation go($project_id: String!, $user_id: Int!){
    exportFeeProposal(project_id: $project_id, user_id: $user_id)
}`

export default class ExportFeeProposalButton extends Component{

    state = {
        dropdownOpen: false,
        exporting: false
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    handleExportUrl = (url) => {
        window.open(url, '_self');
    }

    setExporting = (exporting) => {
        this.setState({exporting})
    }

    handleExport = (go, user_id) => {
        const {project_id} = this.props
        this.setExporting(true)
        go({variables: {project_id, user_id}})
            .then(({data}) => {
                this.handleExportUrl(data.exportFeeProposal)
                this.setExporting(false)
            })
    }

    render() {

        return (
            <Mutation mutation={MUTATION}>
                {(go) => (
                    <ButtonDropdown direction="up" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle caret disabled={this.state.exporting}>
                            {(this.state.exporting) ? 'Exporting...': 'Export Fee Proposal'}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem header>Export As</DropdownItem>
                            <DropdownItem onClick={() => this.handleExport(go, 167)}>Jon Evans</DropdownItem>
                            <DropdownItem onClick={() => this.handleExport(go, 1)}>Mark Ryan</DropdownItem>
                            <DropdownItem onClick={() => this.handleExport(go, 2)}>Tony Watkin</DropdownItem>
                        </DropdownMenu>
                    </ButtonDropdown>
                )}

            </Mutation>
        )

    }

}